export default "__VITE_ASSET__BOfeZ1Y6__"